import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './restore_password.component.html'
})
export class RestorePasswordModalComponent extends BaseSupportModalComponent {
	userId: string;

	async ok() {
		await this.supportService.restorePassword(this.userId, this.spreader.base.comment).toPromise();

		this.execute();
	}
}
